// WARRANTY MUTATIONS
export const WARRANTY_MODULE_NAME = 'warranty'
export const WARRANTY_CLEAR_MODULE = 'WARRANTY_CLEAR_MODULE'
export const WARRANTY_UPDATE_CREATED = 'WARRANTY_UPDATE_CREATED'
export const WARRANTY_UPDATE_SINISTER_ID = 'WARRANTY_UPDATE_SINISTER_ID'
export const WARRANTY_UPDATE_SECONDARY_ID = 'WARRANTY_UPDATE_SECONDARY_ID'
export const WARRANTY_UPDATE_ADDRESS = 'WARRANTY_UPDATE_ADDRESS'
export const WARRANTY_UPDATE_ZIP_CODE = 'WARRANTY_UPDATE_ZIP_CODE'
export const WARRANTY_UPDATE_COORDINATES = 'WARRANTY_UPDATE_COORDINATES'
export const WARRANTY_UPDATE_MORE_THAN_TWO_YEARS =
  'WARRANTY_UPDATE_MORE_THAN_TWO_YEARS'
export const WARRANTY_UPDATE_PROPERTY_TYPE = 'WARRANTY_UPDATE_PROPERTY_TYPE'
export const WARRANTY_UPDATE_RESIDENT_TYPE = 'WARRANTY_UPDATE_RESIDENT_TYPE'
export const WARRANTY_UPDATE_DAMAGE_REP_TYPE_CODE =
  'WARRANTY_UPDATE_DAMAGE_REP_TYPE_CODE'
export const WARRANTY_UPDATE_SINISTER_SUMMARY =
  'WARRANTY_UPDATE_SINISTER_SUMMARY'
export const WARRANTY_UPDATE_REPORT = 'WARRANTY_UPDATE_REPORT'
export const WARRANTY_UPDATE_MATERIAL_SUMMARY =
  'WARRANTY_UPDATE_MATERIAL_SUMMARY'
export const WARRANTY_UPDATE_PROPS = 'WARRANTY_UPDATE_PROPS'
export const WARRANTY_UPDATE_REPAIR_TYPE = 'WARRANTY_UPDATE_REPAIR_TYPE'
export const WARRANTY_UPDATE_LAST_PIECE_SELECTED =
  'WARRANTY_UPDATE_LAST_PIECE_SELECTED'
export const WARRANTY_UPDATE_PIECES_SURFACE = 'WARRANTY_UPDATE_PIECES_SURFACE'
export const WARRANTY_UPDATE_FLUXID = 'WARRANTY_UPDATE_FLUXID'
export const WARRANTY_UPDATE_SHOW_EXTRA_INFO = 'WARRANTY_UPDATE_SHOW_EXTRA_INFO'
export const WARRANTY_EXISTING_SINISTER = 'WARRANTY_EXISTING_SINISTER'
export const WARRANTY_UPDATE_ANSWERED_EXTRA_INFO = 'WARRANTY_UPDATE_ANSWERED_EXTRA_INFO'

// WARRANTY ADITIONAL INFO
export const WARRANTY_MODULE_ADDITIONAL_INFO = 'additionalInfo'
export const WARRANTY_UPDATE_ADDITIONAL_INFO = 'WARRANTY_UPDATE_ADDITIONAL_INFO'
export const WARRANTY_UPDATE_NAME = 'WARRANTY_UPDATE_NAME'
export const WARRANTY_UPDATE_SURNAME = 'WARRANTY_UPDATE_SURNAME'
export const WARRANTY_UPDATE_SINISTER_ADDRESS =
  'WARRANTY_UPDATE_SINISTER_ADDRESS'
export const WARRANTY_UPDATE_EMAIL = 'WARRANTY_UPDATE_EMAIL'
export const WARRANTY_UPDATE_SINISTER_DATE = 'WARRANTY_UPDATE_SINISTER_DATE'
export const WARRANTY_UPDATE_POLICE = 'WARRANTY_UPDATE_POLICE'
export const WARRANTY_UPDATE_SCORE_ASK = 'WARRANTY_UPDATE_SCORE_ASK'
export const WARRANTY_UPDATE_VALIDATE_CONTRACT =
  'WARRANTY_UPDATE_VALIDATE_CONTRACT'
export const WARRANTY_UPDATE_INMOBILIER = 'WARRANTY_UPDATE_INMOBILIER'
export const WARRANTY_UPDATE_EMBELLISSEMENT = 'WARRANTY_UPDATE_EMBELLISSEMENT'
export const WARRANTY_UPDATE_MOBILIER = 'WARRANTY_UPDATE_MOBILIER'
export const WARRANTY_UPDATE_PISCINE = 'WARRANTY_UPDATE_PISCINE'
export const WARRANTY_UPDATE_EXTERIEUR = 'WARRANTY_UPDATE_EXTERIEUR'
export const WARRANTY_UPDATE_CURRENT_CLAIM = 'WARRANTY_UPDATE_CURRENT_CLAIM'
export const WARRANTY_UPDATE_LITIGATION_ALERT_ABSENCE =
  'WARRANTY_UPDATE_LITIGATION_ALERT_ABSENCE'
export const WARRANTY_UPDATE_GAG_NUMBER = 'WARRANTY_UPDATE_GAG_NUMBER'
export const WARRANTY_UPDATE_REN_NUMBER = 'WARRANTY_UPDATE_REN_NUMBER'
export const WARRANTY_UPDATE_SINISTER_CAUSE = 'WARRANTY_UPDATE_SINISTER_CAUSE'
export const WARRANTY_UPDATE_SINISTER_PLACE = 'WARRANTY_UPDATE_SINISTER_PLACE'
export const WARRANTY_UPDATE_DAMAGE_PLACE = 'WARRANTY_UPDATE_DAMAGE_PLACE'
export const WARRANTY_UPDATE_CAUSE_REPAIRED = 'WARRANTY_UPDATE_CAUSE_REPAIRED'
export const WARRANTY_UPDATE_THIRD_PARTY_INVOLVED =
  'WARRANTY_UPDATE_THIRD_PARTY_INVOLVED'

// WARRANTY UPDATE AREA
export const WARRANTY_UPDATE_HEIGHT = 'WARRANTY_UPDATE_HEIGHT'
export const WARRANTY_UPDATE_WIDTH = 'WARRANTY_UPDATE_WIDTH'
export const WARRANTY_UPDATE_AREA = 'WARRANTY_UPDATE_AREA'
export const WARRANTY_UPDATE_UNIT = 'WARRANTY_UPDATE_UNIT'

// WARRANTY ACTIONS
export const WARRANTY_GET_SINISTER_SUMMARY = 'WARRANTY_GET_SINISTER_SUMMARY'
export const WARRANTY_DELETE_DAMAGE = 'WARRANTY_DELETE_DAMAGE'
export const WARRANTY_GET_REPORT = 'WARRANTY_GET_REPORT'
export const WARRANTY_PATCH_REPAIR_TYPE = 'WARRANTY_PATCH_REPAIR_TYPE'
export const WARRANTY_GET_MATERIAL_SUMMARY = 'WARRANTY_GET_MATERIAL_SUMMARY'
export const WARRANTY_GET_SINISTER = 'WARRANTY_GET_SINISTER'
export const WARRANTY_UPDATE_DAMAGE_REPARATION_TYPE =
  'WARRANTY_UPDATE_DAMAGE_REPARATION_TYPE'

// USER MODULE
export const USER_MODULE_NAME = 'user'
export const USER_CLEAR_MODULE = 'USER_CLEAR_MODULE'
export const USER_UPDATE_ROUTES = 'USER_UPDATE_ROUTES'
export const USER_SET_ROLE = 'USER_SET_ROLE'
export const USER_UPDATE_IS_COMPANYADMIN = 'USER_UPDATE_IS_COMPANYADMIN'
export const USER_UPDATE_IS_SUPERADMIN = 'USER_UPDATE_IS_SUPERADMIN'
export const USER_UPDATE_IS_SELFCAREADMIN = 'USER_UPDATE_IS_SELFCAREADMIN'
export const USER_GET_SINISTERS = 'USER_GET_SINISTERS'
export const USER_UPDATE_SINISTERS = 'USER_UPDATE_SINISTERS'
export const USER_SET_MODE = 'USER_SET_MODE'
export const USER_REDUX_MODE = 'REDUX'
export const USER_UPDATE_IS_MIX_ENABLE = 'USER_UPDATE_IS_MIX_ENABLE'
// MAIN
export const UPDATE_LOADER = 'UPDATE_LOADER'
export const UPDATE_VIEW = 'UPDATE_VIEW'
